import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { AutoComplete, AutoCompleteCompleteMethodParams } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';

import DemandController from '../../controllers/Demands/DemandController';
import { Toast } from 'primereact/toast';
import { InputMask } from 'primereact/inputmask';
import { Calendar } from 'primereact/calendar';

interface filteredProps {
	label: string;
	value?: string;
}

interface filteredDemand {
	label: string;
	value?: number;
}

type Country = {
	name: string;
};

type OrgaoUnidade = {
	value: string | undefined;
	label: string;
}

type Responsavel = {
	value: string | undefined;
	label: string;
}

type Veiculo = {
	value: string | undefined;
	label: string;
}


const DemandForm: React.FC = () => {
	const { getDemandData, dataResponse } = DemandController();
	const { formik, toast, unitys, prioritys, vehicles, managers, stocks, fuels } = getDemandData;

	const [filteredUnity, setFilteredUnity] = useState<filteredProps[]>([{ label: '', value: '' }]);
	const [filteredPriority, setFilteredPriority] = useState<filteredProps[]>([{ label: '', value: '' }]);
	const [filteredVehicle, setFilteredVehicle] = useState<filteredProps[]>([{ label: '', value: '' }]);
	const [filteredManager, setFilteredManager] = useState<filteredProps[]>([{ label: '', value: '' }]);
	const [filteredDemand, setFilteredDemand] = useState<filteredDemand[]>([{ label: '', value: 0 }]);
	const [filteredFuels, setFilteredFuels] = useState<filteredProps[]>([{ label: '', value: '' }]);
	const [filteredStocks, setFilteredStocks] = useState<filteredProps[]>([{ label: '', value: '' }]);

	const [valueUnity, setValueUnity] = useState('');
	const [valuePriority, setValuePriority] = useState('');
	const [valueVehicle, setValueVehicle] = useState('');
	const [valueManager, setValueManager] = useState('');
	const [valueDemand, setValueDemand] = useState('');
	const [valueStock, setValueStock] = useState('');
	const [valueFuel, setValueFuel] = useState('');
	const [valueIntinerary, setValueIntinerary] = useState('');
	const [valueQuantity, setValueQuantity] = useState(0);
	const [valueDataInicio, setValueDataInicio] = useState('');
	const [valueDataFim, setValueDataFim] = useState('');
	const [description, setDescription] = useState('');
	const [registerFinished, setRegisterFinished] = useState(false);
	const [editMode, setEditMode] = useState(false);

	//
	const [fuelType, setFuelType] = useState<boolean>(false);
	const [originDemands, setOriginDemands] = useState<boolean>(false);

	const history: any = useHistory();

	const state = history.location.state;


	///// ORGAO UNIDADE
	const [selectedOrgaoUnidade, setSelectedOrgaoUnidade] = useState<OrgaoUnidade | null>(null);
	const [filteredOrgaoUnidade, setFilteredOrgaoUnidade] = useState<OrgaoUnidade[]>([]);
	const orgaoUniades: OrgaoUnidade[] = [...unitys];
	const searchOrgaoUnidade = (event: AutoCompleteCompleteMethodParams) => {
		const query = event.query.toLowerCase();
		const results = orgaoUniades.filter(orgaoUniade =>
			orgaoUniade.label.toLowerCase().includes(query)
		);
		setFilteredOrgaoUnidade(results);
	};
	/////
	///// RESPONSAVEL
	const [selectedResponsavel, setSelectedResponsavel] = useState<Responsavel | null>(null);
	const [filteredResponsavel, setFilteredResponsavel] = useState<Responsavel[]>([]);
	const responsavels: Responsavel[] = [...managers];
	const searchResponsavel = (event: AutoCompleteCompleteMethodParams) => {
		const query = event.query.toLowerCase();
		const results = responsavels.filter(responsavel =>
			responsavel.label.toLowerCase().includes(query)
		);
		setFilteredResponsavel(results);
	};
	/////
	///// VEICULO
	const [selectedVeiculo, setSelectedVeiculo] = useState<Veiculo | null>(null);
	const [filteredVeiculo, setFilteredVeiculo] = useState<Veiculo[]>([]);
	const veiculos: Veiculo[] = [...vehicles];
	const searchVeiculo = (event: AutoCompleteCompleteMethodParams) => {
		const query = event.query.toLowerCase();
		const results = veiculos.filter(veiculo =>
			veiculo.label.toLowerCase().includes(query)
		);
		setFilteredVeiculo(results);
	};
	/////


	useEffect(() => {
		if (state && state.prevPath === '/listSendedsDemands') {
			setOriginDemands(true);
		}
	}, [state]);

	useEffect(() => {
		if (dataResponse.response?.status === 200) {
			setRegisterFinished(true);
		}
		if (dataResponse.response?.status !== 200) {
			setRegisterFinished(false);
		}
	}, [dataResponse.response]);

	const searchUnitys = (event: any) => {
		let filteredUnitys;
		if (!event.query.trim().length) {
			filteredUnitys = [...unitys];
		} else {
			filteredUnitys = unitys.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredUnity(filteredUnitys);
	};

	const searchPrioritys = (event: any) => {
		let filteredPrioritys;
		if (!event.query.trim().length) {
			filteredPrioritys = [...prioritys];
		} else {
			filteredPrioritys = prioritys.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredPriority(filteredPrioritys);
	};

	const searchVehicles = (event: any) => {
		let filteredVehicles;
		if (!event.query.trim().length) {
			filteredVehicles = [...vehicles];
		} else {
			filteredVehicles = vehicles.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredVehicle(filteredVehicles);
	};

	const searchManagers = (event: any) => {
		let filteredManagers;
		if (!event.query.trim().length) {
			filteredManagers = [...managers];
		} else {
			filteredManagers = managers.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredManager(filteredManagers);
	};

	const searchStocks = (event: any) => {
		let filteredStocks;
		if (!event.query.trim().length) {
			filteredStocks = [...stocks];
		} else {
			filteredStocks = managers.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredStocks(filteredStocks);
	};

	const searchFuels = (event: any) => {
		let filteredFuels;
		if (!event.query.trim().length) {
			filteredFuels = [...fuels];
		} else {
			filteredFuels = fuels.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredFuels(filteredFuels);
	};

	const demandsType = [
		{ label: 'COMBUSTÍVEL', value: 0 },
		{ label: 'SERVIÇO', value: 1 },
	];

	const searchTypesOfDemand = (event: any) => {
		let filteredDemand;
		if (!event.query.trim().length) {
			filteredDemand = [...demandsType];
		} else {
			filteredDemand = demandsType.filter(demand => {
				return demand.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredDemand(filteredDemand);
	};

	return (
		<div>
			<Toast ref={toast} />

			<div style={{ height: '100%' }} className='card p-align-center p-justify-center'>
				<h5>Nova demanda</h5>
				<div className='p-grid p-fluid'>
					<div className='p-field p-col-12 p-md-4'>
						<label htmlFor='descricao'>Setor</label>

						<AutoComplete
							id="ORGAOUNIDADEDESTINO"
							value={selectedOrgaoUnidade}
							suggestions={filteredOrgaoUnidade}
							completeMethod={searchOrgaoUnidade}
							onSelect={e => {
								setValueUnity(e.value.label);
								formik.setFieldValue('ORGAOUNIDADEDESTINO', e.value.value);
							}}
							field="label"
							dropdown
							onChange={(e) => {
								setSelectedOrgaoUnidade(e.value)
								formik.setFieldValue(
									'ORGAOUNIDADEDESTINO',
									filteredUnity.find(unityDest => {
										return e.value === unityDest.label;
									})?.value || '',);
							}}
							placeholder="Selecione o Setor..."
						/>

						{/*<AutoComplete
							id='ORGAOUNIDADEDESTINO'
							value={valueUnity}
							field='label'
							disabled={registerFinished}
							onChange={e => {
								setValueUnity(e.value.label);
								formik.setFieldValue(
									'ORGAOUNIDADEDESTINO',
									filteredUnity.find(unityDest => {
										return e.value === unityDest.label;
									})?.value || '',
								);
							}}
							onSelect={e => {
								setValueUnity(e.value.label);
								formik.setFieldValue('ORGAOUNIDADEDESTINO', e.value.value);
							}}
							suggestions={filteredUnity}
							completeMethod={searchUnitys}
							dropdown
							placeholder='Selecione a Unidade...'
						/>*/}
					</div>
					<div className='p-field p-col-12 p-md-4'>
						<label htmlFor='descricao'>Responsável</label>
						<AutoComplete
							id="PESSOADESTINO"
							value={selectedResponsavel}
							suggestions={filteredResponsavel}
							completeMethod={searchResponsavel}
							disabled={registerFinished || !valueUnity}
							onSelect={e => {
								setValueManager(e.value.label);
								formik.setFieldValue('PESSOADESTINO', e.value.value);
							}}
							field="label"
							dropdown
							onChange={(e) => {
								setSelectedResponsavel(e.value)
								formik.setFieldValue(
									'PESSOADESTINO',
									filteredManager.find(manager => {
										return e.value === manager.label;
									})?.value || '',);
							}}
							placeholder="Selecione a Responsável..."
						/>
						{/*<AutoComplete
							id='PESSOADESTINO'
							value={valueManager}
							field='label'
							disabled={registerFinished || !valueUnity}
							onChange={e => {
								setValueManager(e.value.label);
								formik.setFieldValue(
									'PESSOADESTINO',
									filteredManager.find(manager => {
										return e.value === manager.label;
									})?.value || '',
								);
							}}
							onSelect={e => {
								setValueManager(e.value.label);
								formik.setFieldValue('PESSOADESTINO', e.value.value);
							}}
							suggestions={filteredManager}
							completeMethod={searchManagers}
							dropdown
							placeholder='Selecione o Responsável...'
						/>*/}
					</div>
					<div className='p-field p-col-12 p-md-4'>
						<label htmlFor='descricao'>Prioridade</label>
						<AutoComplete
							id='prioridade'
							value={valuePriority}
							field='label'
							disabled={registerFinished}
							onChange={e => {
								setValuePriority(e.value.label);
								formik.setFieldValue(
									'PRIORIDADE',
									filteredPriority.find(priority => {
										return e.value === priority.label;
									})?.value || '',
								);
							}}
							onSelect={e => {
								setValuePriority(e.value.label);
								formik.setFieldValue('PRIORIDADE', e.value.value);
							}}
							suggestions={filteredPriority}
							completeMethod={searchPrioritys}
							dropdown
							placeholder='Defina a prioridade...'
						/>
					</div>
					<div className='p-field p-col-12 p-md-4'>
						<label htmlFor='descricao'>Digite a sua demanda:</label>
						<InputTextarea
							autoResize
							value={description}
							placeholder='Detalhe a sua demanda...'
							maxLength={250}
							disabled={registerFinished}
							onChange={e => {
								setDescription(e.target.value);
								formik.setFieldValue('DESCRICAO', e.target.value);
							}}
						/>
					</div>
					<div className='p-field p-col-12 p-md-4'>
						<label htmlFor='descricao'>Tipo da Demanda</label>
						<AutoComplete
							id='TIPODEMANDA'
							value={valueDemand}
							field='label'
							disabled={registerFinished}
							onChange={e => {
								setValueDemand(e.value.label);
								formik.setFieldValue(
									'TIPODEMANDA',
									filteredDemand.find(demand => {
										return e.value === demand.label;
									})?.value || '',
								);
								if (e.value.label === 'COMBUSTÍVEL') {
									setFuelType(true);
								} else {
									setFuelType(false);
								}
							}}
							onSelect={e => {
								setValueDemand(e.value.label);
								formik.setFieldValue('TIPODEMANDA', e.value.value);
							}}
							suggestions={filteredDemand}
							completeMethod={searchTypesOfDemand}
							dropdown
							placeholder='Selecione o tipo demanda...'
						/>
					</div>

					{fuelType ? (
						<div className='p-field p-col-12 p-md-4'>
							<label htmlFor='descricao'>Destino do Intinerário</label>
							<InputText
								type={'text'}
								value={valueIntinerary}
								disabled={registerFinished}
								onChange={e => {
									setValueIntinerary(e.target.value);
									formik.setFieldValue('ITINERARIO', e.target.value);
								}}
								placeholder='Digite seu destino...'
							/>
						</div>
					) : null}
					{fuelType && formik.values.ITINERARIO ? (
						<>
							<div className='p-field p-col-12 p-md-2'>
								<label htmlFor='descricao'>Tipo de Combustível</label>
								<AutoComplete
									id='COMBUSTIVEL'
									value={valueFuel}
									field='label'
									disabled={registerFinished}
									onChange={e => {
										setValueFuel(e.value.label);
										formik.setFieldValue(
											'FT_TIPOCOMBUSTIVEL',
											filteredFuels.find(fuel => {
												return e.value === fuel.label;
											})?.value || '',
										);
									}}
									onSelect={e => {
										setValueFuel(e.value.label);
										formik.setFieldValue('FT_TIPOCOMBUSTIVEL', e.value.value);
									}}
									suggestions={filteredFuels}
									completeMethod={searchFuels}
									dropdown
									placeholder='Tipo de Combustível...'
								/>
							</div>
							<div className='p-field p-col-12 p-md-2'>
								<label htmlFor='descricao'>Quantidade solicitada (em Litros)</label>
								<InputText
									type={'number'}
									value={valueQuantity}
									disabled={registerFinished || !valueFuel}
									placeholder='Digite a quantidade solicitada...'
									onChange={e => {
										if (Number(e.target.value) > 0) {
											setValueQuantity(Number(e.target.value));
											formik.setFieldValue(
												'QUANTIDADECOMBUSTIVELSOLICITADO',
												Number(e.target.value),
											);
										} else {
											setValueQuantity(0);
											formik.setFieldValue('QUANTIDADECOMBUSTIVELSOLICITADO', 0);
										}
									}}
								/>
							</div>
						</>
					) : null}

					<div className='p-field p-col-12 p-md-4'>
						<label htmlFor='estoque'>Estoque</label>
						<div className='p-inputgroup'>
							<AutoComplete
								disabled={registerFinished}
								id='estoque'
								dropdown
								placeholder='Selecione o estoque...'
								value={valueStock}
								onChange={e => {
									setValueStock(e.value.label);
									formik.setFieldValue(
										'ESTOQUE',
										filteredStocks.find(stock => {
											return e.value === stock.label;
										})?.value || '',
									);
								}}
								onSelect={e => {
									setValueStock(e.value.label);
									formik.setFieldValue('ESTOQUE', e.value.value);
								}}
								suggestions={filteredStocks}
								field='label'
								completeMethod={searchStocks}
							/>
						</div>
					</div>

					<div className='p-field p-col-12 p-md-4'>
						<label htmlFor='descricao'>Veículo</label>
						<AutoComplete
							id="vehicle"
							value={selectedVeiculo}
							suggestions={filteredVeiculo}
							completeMethod={searchVeiculo}
							disabled={registerFinished || !valueStock}
							onSelect={e => {
								setValueVehicle(e.value.label);
								formik.setFieldValue('FT_VEICULO', e.value.value);
							}}
							field="label"
							dropdown
							onChange={(e) => {
								setSelectedVeiculo(e.value)
								formik.setFieldValue(
									'FT_VEICULO',
									filteredVehicle.find(vehicle => {
										return e.value === vehicle.label;
									})?.value || '',
								);
							}}
							placeholder="Selecione a Veículo..."
						/>
						{/*<AutoComplete
							id='vehicle'
							value={valueVehicle}
							field='label'
							disabled={registerFinished || !valueStock}
							onChange={e => {
								setValueVehicle(e.value.label);
								formik.setFieldValue(
									'FT_VEICULO',
									filteredVehicle.find(vehicle => {
										return e.value === vehicle.label;
									})?.value || '',
								);
							}}
							onSelect={e => {
								setValueVehicle(e.value.label);
								formik.setFieldValue('FT_VEICULO', e.value.value);
							}}
							suggestions={filteredVehicle}
							completeMethod={searchVehicles}
							dropdown
							placeholder='Selecione o veículo...'
						/>*/}
					</div>

					<div className='p-field p-col-12 p-md-2'>
						<label htmlFor='descricao'>Data Inicio Validade</label>
						<InputMask
							type={'text'}
							mask='99/99/9999'
							value={valueDataInicio}
							disabled={registerFinished || !valueFuel}
							onChange={e => {
								setValueDataInicio(e.target.value);
								formik.setFieldValue('DATAINICIO', e.target.value);
							}}
							placeholder='__/__/____'
						/>
					</div>
					<div className='p-field p-col-12 p-md-2'>
						<label htmlFor='descricao'>Data Fim Validade</label>
						<InputMask
							type={'text'}
							mask='99/99/9999'
							value={valueDataFim}
							disabled={registerFinished || !valueFuel}
							onChange={e => {
								setValueDataFim(e.target.value);
								formik.setFieldValue('DATAFIM', e.target.value);
							}}
							placeholder='__/__/____'
						/>
					</div>

					{fuelType ? <></> : null}
				</div>



				<div className='p-fluid p-grid p-justify-between'>
					{originDemands === true ? (
						<div className='p-col-12 p-md-4'>
							<Button
								type='button'
								className='p-button-secondary'
								label='Voltar para listagem'
								onClick={() => history.goBack()}
							/>
						</div>
					) : (
						<div className='p-col-12 p-md-4'>
							<Button
								type='button'
								className='p-button-secondary'
								label='Voltar para a página anterior'
								onClick={() => history.goBack()}
							/>
						</div>
					)}

					{registerFinished === true ? (
						<>
							<div className='p-col-12 p-md-3'>
								<Button
									icon='pi pi-plus'
									type='button'
									className='p-button-success'
									label='Cadastrar novo'
									onClick={() => {
										setRegisterFinished(false);
										history.go(0);
									}}
								/>
							</div>
							<div className='p-col-12 p-md-3'>
								<Button
									type='button'
									label='Editar'
									onClick={() => {
										if (dataResponse.response !== null) {
											formik.setFieldValue('ID', dataResponse.response.data.ID);
										}

										setEditMode(true);
										setRegisterFinished(false);
									}}
								/>
							</div>
						</>
					) : !editMode ? (
						<div className='p-col-12 p-md-4'>
							<Button
								type='button'
								label='Criar demanda'
								onClick={() => {
									formik.handleSubmit();
									setRegisterFinished(true);
								}}
							/>
						</div>
					) : (
						<div className='p-col-12 p-md-4'>
							<Button
								type='button'
								label='Gravar alterações'
								onClick={() => {
									formik.handleSubmit();
									setRegisterFinished(true);
								}}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default DemandForm;
